import type {
  IDemo,
  IPresentation,
  NotesInDesktopMessageProps,
  Play,
  Workspace,
  WorkspaceFolder,
} from '@carboncopyco/types';
import { useBoolean } from 'ahooks';
import constate from 'constate';
import { useState } from 'react';
import type { GoToDemoPreviewArgs } from '../../PresentationModals';

export type OverlayPageProps = {
  readOnly?: boolean;
  rootPath: string;
  updateDemo: () => void;
  goToDemoPreview: (options?: GoToDemoPreviewArgs) => void;
  handleCreatePresentation?: () => void;
  goToPresentation: (presentation: IPresentation) => void;
  goToEditor: () => void;
  handleCreateTour: () => void;
  goBack: () => void;
  organizationId: string;
  demoId: string;
  goToDuplicatedDemo: (demo: IDemo) => void;
  goToCopiedDemo: (demoId: number, workspaceId: Workspace['id']) => void;
  clonePath: string;
  goToWorkspacePage: () => void;
  workspaceId: string;
  goToLinksTab?: () => void;
  playPresentation?: (play: Play) => void;
  desktopDomain?: string;
  goToFolderPage?: (
    folderId: WorkspaceFolder['id'],
    workspaceId: Workspace['id']
  ) => void;
};

export type OverlayPageState = OverlayPageProps &
  NotesInDesktopMessageProps & {
    noteValue: string;
    setNoteValue: (value: string) => void;
    pendingNavigationRoute: string;
    setPendingNavigationRoute: (route: string) => void;
  };

const useOverlayPage = (props: OverlayPageProps): OverlayPageState => {
  const [noteValue, setNoteValue] = useState('');
  const [pendingNavigationRoute, setPendingNavigationRoute] =
    useState<string>();
  const [showNotesInDesktopMessage, setShowNotesInDesktopMessage] =
    useBoolean(true);

  return {
    ...props,
    noteValue,
    setNoteValue,
    showNotesInDesktopMessage,
    pendingNavigationRoute,
    setPendingNavigationRoute,
    onCloseNotesInDesktopMessage: setShowNotesInDesktopMessage.setFalse,
  };
};

export const [OverlayPageProvider, useOverlayPageProps] =
  constate(useOverlayPage);
